<template>
    <div class="fixed_login_logout">
        <b-spinner type="grow" style="float:right" v-if="$auth.loading">
        *** Auth is loading ***
        </b-spinner>
        <div style="float:right;" v-if="!$auth.loading">
            <!-- show login when not authenticated -->
            <b-button v-if="!$auth.isAuthenticated" style="height: 25px; padding-top: 0; margin-right: 5px" @click="login">Logga in</b-button>
            <!-- show logout when authenticated -->
            <div v-if="$auth.isAuthenticated" style="text-shadow:-1px 1px 2px black;">
              <div style="height:27px; margin-top: 0px;">
                <router-link to="/profile" class="userName">
                <img style="border-radius: 13px; vertical-align: middle" :src="$auth.user.picture" width="26px">
                <span v-if="!computedMobileMode" style="vertical-align: middle; font-size: 90%">&nbsp;{{ $auth.user.name }}</span> <b-button style="height: 25px; padding-top: 0px; margin-right: 15px" @click="logout">Logga ut</b-button>
                </router-link>
              </div>
            </div>
          </div>
    </div>
</template>

<script>
    import {globalStore} from '../main.js'

    export default {
        name: 'LoginLogout',
        data() {
            return {
            }
        },
        computed: {
            computedMobileMode: function () {
                // We fetch the value of the global variable "mobileMode" here.
                // We have put it in the "computed" section so that it will be
                // re-calculated on each render.
                return globalStore.mobileMode
            }
        },
        methods: {
            // Log the user in
            async login() {
                this.$auth.loginWithRedirect();
            },
            // Log the user out
            logout() {
                localStorage.ott = null;
                this.$auth.logout({
                    returnTo: window.location.origin + process.env.BASE_URL
                });
            },
        }
    }
    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
#breadcrumb {
    color: #ff3eff;
}
.fixed_login_logout {
    position: fixed; /* fixing the position takes it out of html flow - knows
            nothing about where to locate itself except by browser
            coordinates */
    float:right;
    top: 0px; /* top left corner should start at topmost spot */
    right: -1px;
    width: 50vw; /* take up the full browser width */
    z-index: 202; /* high z index so other content scrolls underneath */
    height: 25px; /* define height for content */
}
.fixed_header {
    position: fixed; /* fixing the position takes it out of html flow - knows
            nothing about where to locate itself except by browser
            coordinates */
    top: 0px; /* top left corner should start at topmost spot */
    width: 100vw; /* take up the full browser width */
    z-index: 201; /* high z index so other content scrolls underneath */
    height: 25px; /* define height for content */
}

.grid-container_mobile {
    background-color: black;
    //display: grid;
    //grid-auto-flow: row;
}

.grid-container {
    //border: 1px;
    width: 100%;
    background-color: black;
    /*display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0px;
    grid-auto-flow: column;*/
    /*grid-auto-rows: minmax(100px, auto);
    grid-template-rows: repeat(auto-fill, 100px);
  grid-template-columns: repeat(auto-fill, 100px);
  grid-auto-columns: 100px;
  grid-auto-rows: 100px;*/
}

.caption {
    margin-top: 5px;
}

.video_mobile {
    width: 100%;
}

.video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.video33_mobile {
    //border: 1px solid red;
    display: block;
}

.video33 {
    //border: 1px solid red;
    //display: block;
    float: left;
    width: 320px; height: 320px;
    padding: 20px;
    
    //margin-left: auto;
    //margin-right: auto;
    //object-fit: cover;
}
.video50 {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    height: 100%;
}
.video100 {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    height: 100%;
}
</style>
